import React from 'react'

import {
  Grid,
} from '@mui/material'

import LandingHeader from './header'
import LandingWho from './who'
import LandingHow from './how'
import LandingWhom from './whom'
import LandingWhen from './when'
import LandingInterested from './interested'
import LandingWhy from './why'

const LandingHome = () => {
  return (
    <Grid container spacing={0} sx={{ bgcolor: 'white' }}>
      <Grid item xs={12}>
        <LandingHeader />
      </Grid>
      <Grid item xs={12}>
        <LandingWho />
      </Grid>
      <Grid item xs={12}>
        <LandingHow />
      </Grid>
      <Grid item xs={12}>
        <LandingWhy />
      </Grid>
      <Grid item xs={12}>
        <LandingWhom />
      </Grid>
      <Grid item xs={12}>
        <LandingInterested />
      </Grid>
      <Grid item xs={12}>
        <LandingWhen />
      </Grid>
    </Grid>
  )
}

export default LandingHome